import { RcClasses } from '../../../../foundation';
export var RcTabClasses = RcClasses(['labelIcon', 'wrapper', 'selected'], 'RcTab');
